import { PRIMITIVE_COLOR_PALETTES } from '@/adapters/primitive/_data/config/fragments/colorPalettes';

export const PRIMITIVE_PRESENTATION_DEFAULTS = {
    /** 2 doubles durations; 0.5 halves them. Independent of the workflow runner multiplier. */
    animationDurationMultiplier: 2,
    colors: PRIMITIVE_COLOR_PALETTES.beta,
} as const;